import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { Link } from "react-router-dom";
import { ReviewDbDto } from "../common/dto/ReviewDbDto";
import { formatDate } from "../util";

type Props = { username: string }

export default class ReviewList
    extends Component<ServiceCollectionParam & Props, { reviews: ReviewDbDto[] }> {

    state: { reviews: ReviewDbDto[] } = {
        reviews: []
    }

    async componentDidMount() {
        let username = this.props.username;

        this.state.reviews = await this.props.services.dao
            .findReviewsAssignedTo(username);

        this.setState(this.state);
    }

    render() {
        return (
            <>
            <table className="table table-sm caption-top user-dashboard">
                <caption>Koodi ülevaatused</caption>
                <thead>
                <tr>
                    <th scope="col">Tag</th>
                    <th scope="col">Räsi</th>
                    <th scope="col">Autor</th>
                    <th scope="col">Tähtaeg</th>
                    <th scope="col">Esitatud</th>
                </tr>
                </thead>
                <tbody>
                { this.state.reviews.map(row =>
                    <tr key={row._id}>
                        <td><Link to={'/review/' + row._id}>{row.tag}</Link></td>
                        <td>{ row.hash }</td>
                        <td>{ row.codeAuthorName }</td>
                        <td>{ formatDate(row.dueDate) }</td>
                        <td>{ formatDate(row.submittedDate) }</td>
                    </tr>
                )}
                </tbody>
            </table>
            </>);
    }

}

